// Single source of truth for all project data
// Update these values as needed - all components and schema reference this file

export const projectData = {
  // Core Project Info
  projectName: 'Nahar Chandi Valley',
  tagline: 'Luxury Residences in Chandivali–Powai, Mumbai',
  domain: 'https://chandivalleynahar.com',
  
  // Developer Info
  developer: {
    name: 'Nahar Group',
    description: 'Legacy developer with decades of excellence in Mumbai real estate',
    logo: '/logo.png',
  },
  
  // Compliance
  rera: {
    number: 'P51800002500059',
    authority: 'MahaRERA',
    verifyUrl: 'https://maharera.mahaonline.gov.in/',
  },
  
  // Pricing (indicative)
  pricing: {
    startingPrice: '₹2.90 Cr',
    startingPriceNumeric: 29000000,
    priceNote: 'onwards*',
    disclaimer: 'Prices are indicative and subject to change without notice.',
    // Unified disclaimer for all channels
    fineprint: 'Prices mentioned are indicative and exclude stamp duty, registration charges, GST, and other applicable taxes. Final pricing may vary based on configuration, floor, and availability.',
    fineprintShort: 'Prices indicative. Excludes stamp duty, GST & registration.',
  },
  
  // Possession
  possession: {
    date: 'Dec 2030',
    note: 'Subject to approvals and construction progress',
  },
  
  // Location
  location: {
    address: 'Sales Office, Chandivali, Mumbai 400072, Maharashtra',
    city: 'Mumbai',
    state: 'Maharashtra',
    pincode: '400072',
    country: 'India',
    coordinates: {
      lat: 19.1099,
      lng: 72.8985,
    },
  },
  
  // Contact
  contact: {
    phone: '+919820188150',
    phoneDisplay: '+91 98201 88150',
    phoneE164: '+919820188150',
    whatsappNumber: '919820188150',
    email: 'naharchandivalley@gmail.com',
    siteVisitTimings: 'Mon – Sun: 10:00 AM – 7:00 PM',
  },
  
  // Social Media
  social: {
    facebook: '#',
    instagram: '#',
    youtube: '#',
    linkedin: '#',
  },
};

// Navigation Links
export const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Price', href: '/price' },
  { label: 'Floor Plans', href: '/floor-plans' },
  { label: 'Amenities', href: '/amenities' },
  { label: 'Gallery', href: '/gallery' },
  { label: 'Location', href: '/location' },
  { label: 'Virtual Tour', href: '/virtual-tour' },
];

// Project Snapshots
export const snapshots = [
  {
    icon: 'MapPin',
    label: 'Location',
    value: 'Chandivali–Powai',
    subtext: 'Mumbai',
  },
  {
    icon: 'Home',
    label: 'Configurations',
    value: '2, 3 & 4 BHK',
    subtext: 'Uber-luxury Residences',
  },
  {
    icon: 'IndianRupee',
    label: 'Starting Price',
    value: '₹2.90 Cr*',
    subtext: 'Onwards',
  },
  {
    icon: 'Calendar',
    label: 'Possession',
    value: 'Dec 2030',
    subtext: 'Subject to approvals',
  },
  {
    icon: 'FileCheck',
    label: 'RERA',
    value: 'Registered',
    subtext: 'P51800002500059',
  },
];

/**
 * WING-BASED PRICING DATA
 * Verified from official RERA floor plan PDFs
 * Total Area = RERA Carpet + Deck + Utility (where applicable)
 * Price Rate: ₹32,700 per sq.ft. (indicative)
 */

/**
 * LAYOUTS LIBRARY - Wing layouts, master layout, refuge floors
 * For /floor-plans page - document library only (not config cards)
 */
export const layoutLibrary = [
  // Master Layout
  {
    id: 'master-layout',
    name: 'Master Site Plan',
    description: 'Complete project layout with all 4 wings, landscaping, and amenities',
    category: 'Master Plan',
    path: '/floor-plans/master-layout.pdf',
    thumbnail: null, // Optional: add thumbnail image path
  },
  // Wing Typical Floors
  {
    id: 'ab-wing-typical',
    name: 'A&B Wing Typical Floor',
    description: '4 units per floor: 2 BHK + 3 BHK M1 configurations',
    category: 'Wing Layouts',
    path: '/floor-plans/ab-wing-typical-floor.pdf',
    thumbnail: null,
  },
  {
    id: 'cd-wing-typical',
    name: 'C&D Wing Typical Floor',
    description: '4 units per floor: 3 BHK S, M1, M2, L configurations',
    category: 'Wing Layouts',
    path: '/floor-plans/cd-wing-typical-floor.pdf',
    thumbnail: null,
  },
  {
    id: 'd-wing-typical',
    name: 'D Wing Typical Floor',
    description: 'Premium 3 BHK L + 4 BHK configurations',
    category: 'Wing Layouts',
    path: '/floor-plans/d-wing-typical-floor.pdf',
    thumbnail: null,
  },
  // Refuge Floors
  {
    id: 'a-wing-refuge',
    name: 'A Wing Refuge Floor',
    description: 'Fire safety refuge floor layout',
    category: 'Refuge Floors',
    path: '/floor-plans/a-wing-refuge-floor.pdf',
    thumbnail: null,
  },
  {
    id: 'b-wing-refuge',
    name: 'B Wing Refuge Floor',
    description: 'Fire safety refuge floor layout',
    category: 'Refuge Floors',
    path: '/floor-plans/b-wing-refuge-floor.pdf',
    thumbnail: null,
  },
  {
    id: 'cd-wing-refuge-1',
    name: 'C&D Wing Refuge Floor 1',
    description: 'Fire safety refuge floor layout',
    category: 'Refuge Floors',
    path: '/floor-plans/cd-wing-refuge-floor.pdf',
    thumbnail: null,
  },
  {
    id: 'cd-wing-refuge-2',
    name: 'C&D Wing Refuge Floor 2',
    description: 'Fire safety refuge floor layout',
    category: 'Refuge Floors',
    path: '/floor-plans/cd-wing-refuge-floor-2.pdf',
    thumbnail: null,
  },
  {
    id: 'cd-wing-refuge-3',
    name: 'C&D Wing Refuge Floor 3',
    description: 'Fire safety refuge floor layout',
    category: 'Refuge Floors',
    path: '/floor-plans/cd-wing-refuge-floor-3.pdf',
    thumbnail: null,
  },
  {
    id: 'cd-wing-refuge-4',
    name: 'C&D Wing Refuge Floor 4',
    description: 'Fire safety refuge floor layout',
    category: 'Refuge Floors',
    path: '/floor-plans/cd-wing-refuge-floor-4.pdf',
    thumbnail: null,
  },
];

// A&B Wing Configurations
export const wingABConfigs = [
  {
    id: '2bhk-ab',
    type: '2 BHK',
    wing: 'A&B Wing',
    reraCarpet: 823.55,
    deck: 62.32,
    utility: 0,
    totalArea: 885.87,
    totalAreaDisplay: '886 sq.ft.',
    price: '₹2.90 Cr*',
    priceNumeric: 28968000,
    pricePerSqft: '₹32,700/sq.ft.*',
    flats: ['Flat 03 (B Wing)', 'Flat 04 (A Wing)'],
    flatNumbers: ['403', '1103', '404', '1104'],
    features: ['2 Bedrooms', '2 Bathrooms', 'Den/Study Nook', '62 sq.ft. Deck'],
    highlights: 'Compact luxury with dedicated den area, ideal for home office or study.',
    floorPlan: '/floor-plans/2bhk-flat-03.pdf',
    parking: 'Surface Covered Parking: 1',
    roomDimensions: [
      { room: 'Master Bedroom', size: "11' × 14'9\"" },
      { room: 'Bedroom 2', size: "10' × 11'5\"" },
      { room: 'Living', size: "11'6\" × 6'9\"" },
      { room: 'Kitchen', size: "3'6\" × 4'8\"" },
      { room: 'Bathroom 1', size: "5' × 8'" },
      { room: 'Bathroom 2', size: "5' × 8'" },
    ],
  },
  {
    id: '3bhk-m1-ab',
    type: '3 BHK (M1)',
    wing: 'A&B Wing',
    reraCarpet: 1319.67,
    deck: 183.31,
    utility: 33.69,
    totalArea: 1536.67,
    totalAreaDisplay: '1,537 sq.ft.',
    price: '₹5.02 Cr*',
    priceNumeric: 50248000,
    pricePerSqft: '₹32,700/sq.ft.*',
    flats: ['Flat 01 (A Wing)', 'Flat 02 (B Wing)'],
    flatNumbers: ['All floors'],
    features: ['3 Bedrooms', '3 Bathrooms', 'Servant Room', 'Walk-in Wardrobe', 'Utility', '183 sq.ft. Deck'],
    highlights: 'Family-sized 3BHK with servant quarters, walk-in wardrobe, and forest-facing deck.',
    floorPlan: '/floor-plans/3bhk-m1-flat-01.pdf',
    popular: true,
    parking: 'Surface Covered Parking: 2',
    roomDimensions: [
      { room: 'Master Bedroom', size: "12' × 15'9\"" },
      { room: 'Bedroom 2', size: "11' × 12'" },
      { room: 'Bedroom 3', size: "11' × 12'" },
      { room: 'Living', size: "17' × 12'" },
      { room: 'Kitchen', size: "8' × 12'" },
      { room: 'M. Bathroom', size: "9' × 6'" },
      { room: 'Utility', size: "5'7\" × 7'8\"" },
    ],
  },
];

// C&D Wing Configurations
export const wingCDConfigs = [
  {
    id: '3bhk-s-cd',
    type: '3 BHK (S)',
    wing: 'C&D Wing',
    reraCarpet: 1006.11,
    deck: 62.32,
    utility: 0,
    totalArea: 1068.43,
    totalAreaDisplay: '1,068 sq.ft.',
    price: '₹3.49 Cr*',
    priceNumeric: 34937000,
    pricePerSqft: '₹32,700/sq.ft.*',
    flats: ['Flat 03 (C Wing)', 'Flat 04 (C Wing)'],
    flatNumbers: ['P03', '103', '203', '303', '503', '603', '703', '803', '903', '1003', '1203', '1303', '1403'],
    features: ['3 Bedrooms', '3 Bathrooms', 'City & Forest Views', '62 sq.ft. Deck'],
    highlights: 'Entry-level 3BHK with excellent cross-ventilation and dual city/forest views.',
    floorPlan: '/floor-plans/cd-3bhk-s-flat-03.pdf',
    parking: 'Surface Covered Parking: 2',
    roomDimensions: [
      { room: 'Master Bedroom', size: "11' × 14'8\"" },
      { room: 'Bedroom 2', size: "10' × 11'5\"" },
      { room: 'Bedroom 3', size: "11' × 12'" },
      { room: 'Living', size: "12' × 8'" },
      { room: 'Kitchen', size: "11'6\" × 6'9\"" },
      { room: 'Bathroom', size: "8' × 5'" },
    ],
  },
  {
    id: '3bhk-m1-cd',
    type: '3 BHK (M1)',
    wing: 'C&D Wing',
    reraCarpet: 1319.67,
    deck: 183.31,
    utility: 33.69,
    totalArea: 1536.67,
    totalAreaDisplay: '1,537 sq.ft.',
    price: '₹5.02 Cr*',
    priceNumeric: 50248000,
    pricePerSqft: '₹32,700/sq.ft.*',
    flats: ['Flat 01 (C Wing)', 'Flat 02 (D Wing)'],
    flatNumbers: ['All floors'],
    features: ['3 Bedrooms', '3 Bathrooms', 'Servant Room', 'Walk-in Wardrobe', 'Utility', '183 sq.ft. Deck'],
    highlights: 'Family-sized 3BHK with servant quarters, walk-in wardrobe, and forest-facing deck.',
    floorPlan: '/floor-plans/cd-3bhk-m1-flat-01.pdf',
    parking: 'Surface Covered Parking: 2',
    roomDimensions: [
      { room: 'Master Bedroom', size: "12' × 15'9\"" },
      { room: 'Bedroom 2', size: "11' × 12'" },
      { room: 'Bedroom 3', size: "11' × 12'" },
      { room: 'Living', size: "17' × 12'" },
      { room: 'Kitchen', size: "8' × 12'" },
      { room: 'M. Bathroom', size: "9' × 6'" },
      { room: 'Utility', size: "5'7\" × 7'8\"" },
    ],
  },
  {
    id: '3bhk-m2-cd',
    type: '3 BHK (M2)',
    wing: 'C&D Wing',
    reraCarpet: 1257.77,
    deck: 141.44,
    utility: 24.65,
    totalArea: 1423.86,
    totalAreaDisplay: '1,424 sq.ft.',
    price: '₹4.66 Cr*',
    priceNumeric: 46560000,
    pricePerSqft: '₹32,700/sq.ft.*',
    flats: ['Flat 02 (D Wing)'],
    flatNumbers: ['Select floors'],
    features: ['3 Bedrooms', '3 Bathrooms', 'Separate W.C.', 'Utility Room', '141 sq.ft. Deck'],
    highlights: 'Spacious 3BHK with utility room and separate W.C. for guest convenience.',
    floorPlan: '/floor-plans/cd-3bhk-m2-flat-02.pdf',
    parking: 'Surface Covered Parking: 2',
    roomDimensions: [
      { room: 'Master Bedroom', size: "12' × 16'" },
      { room: 'Bedroom 2', size: "12' × 12'5\"" },
      { room: 'Bedroom 3', size: "12' × 15'" },
      { room: 'Living', size: "18' × 13'" },
      { room: 'Kitchen', size: "4' × 5'8\"" },
      { room: 'M. Bathroom', size: "8' × 6'" },
      { room: 'Deck', size: "141 sq.ft." },
    ],
  },
  {
    id: '3bhk-l-cd',
    type: '3 BHK (L)',
    wing: 'D Wing',
    reraCarpet: 1564.33,
    deck: 273.08,
    utility: 26.69,
    totalArea: 1864.11,
    totalAreaDisplay: '1,864 sq.ft.',
    price: '₹6.10 Cr*',
    priceNumeric: 60956000,
    pricePerSqft: '₹32,700/sq.ft.*',
    flats: ['Flat 03 (D Wing)'],
    flatNumbers: ['103', '203', '303', '402', '503', '603', '703', '803'],
    features: ['3 Bedrooms', '4 Bathrooms', 'Walk-in Wardrobe', 'Servant Room', '273 sq.ft. Mega Deck'],
    highlights: 'Premium 3BHK with 4 bathrooms, walk-in wardrobe, and massive 273 sq.ft. forest-facing deck.',
    floorPlan: '/floor-plans/cd-3bhk-l-flat-03.pdf',
    popular: true,
    parking: 'Surface Covered Parking: 2',
    roomDimensions: [
      { room: 'Master Bedroom', size: "12' × 18'" },
      { room: 'Bedroom 2', size: "12' × 14'" },
      { room: 'Bedroom 3', size: "12' × 14'" },
      { room: 'Living', size: "18' × 14'" },
      { room: 'Kitchen', size: "8' × 8'" },
      { room: 'M. Bathroom', size: "5' × 9'" },
      { room: 'Dining', size: "15'4\" × 10'4\"" },
    ],
  },
  {
    id: '4bhk-cd',
    type: '4 BHK',
    wing: 'D Wing',
    reraCarpet: 2177.56,
    deck: 284.38,
    utility: 24.65,
    totalArea: 2486.59,
    totalAreaDisplay: '2,487 sq.ft.',
    price: '₹8.13 Cr*',
    priceNumeric: 81311000,
    pricePerSqft: '₹32,700/sq.ft.*',
    flats: ['Flat 01 (D Wing)'],
    flatNumbers: ['All floors'],
    features: ['4 Bedrooms', '4 Bathrooms', 'Walk-in Wardrobe', 'Servant Room', '284 sq.ft. Deck'],
    highlights: 'Ultra-luxury 4BHK flagship unit with walk-in wardrobe, servant quarters, and expansive deck.',
    floorPlan: '/floor-plans/cd-4bhk-flat-01.pdf',
    parking: 'Surface Covered Parking: 3',
    servantRoom: true,
    roomDimensions: [
      { room: 'Master Bedroom', size: "12' × 16'" },
      { room: 'Bedroom 2', size: "16' × 12'" },
      { room: 'Bedroom 3', size: "18' × 14'1\"" },
      { room: 'Bedroom 4', size: "12' × 14'" },
      { room: 'Living', size: "25'6\" × 20'" },
      { room: 'Kitchen', size: "9'5\" × 9'" },
      { room: 'M. Bathroom', size: "8' × 5'7\"" },
      { room: 'Dining', size: "5' × 12'6\"" },
    ],
  },
];

// Unified configurations (no duplicates) - merges same layouts across wings
export const allConfigs = [
  // 2 BHK - only in A&B Wing
  wingABConfigs.find(c => c.id === '2bhk-ab')!,
  // 3 BHK (S) - only in C&D Wing
  wingCDConfigs.find(c => c.id === '3bhk-s-cd')!,
  // 3 BHK (M2) - only in C&D Wing
  wingCDConfigs.find(c => c.id === '3bhk-m2-cd')!,
  // 3 BHK (M1) - same layout in both wings, merge into one
  {
    ...wingABConfigs.find(c => c.id === '3bhk-m1-ab')!,
    id: '3bhk-m1',
    wing: 'A&B / C&D Wing',
    highlights: 'Family-sized 3BHK with servant quarters, walk-in wardrobe, and 183 sq.ft. forest-facing deck.',
  },
  // 3 BHK (L) - only in D Wing
  wingCDConfigs.find(c => c.id === '3bhk-l-cd')!,
  // 4 BHK - only in D Wing
  wingCDConfigs.find(c => c.id === '4bhk-cd')!,
];

// Legacy pricingCards format (for backward compatibility)
export const pricingCards = [
  {
    type: '2 BHK',
    carpet: '886 sq.ft.',
    price: '₹2.90 Cr*',
    pricePerSqft: '₹32,700/sq.ft.*',
    wing: 'A&B Wing',
    features: ['Living Room', 'Deck', '2 Washrooms'],
    popular: false,
  },
  {
    type: '3 BHK (S)',
    carpet: '1,068 sq.ft.',
    price: '₹3.49 Cr*',
    pricePerSqft: '₹32,700/sq.ft.*',
    wing: 'C&D Wing',
    features: ['Compact Layout', 'Deck', '3 Washrooms'],
    popular: false,
  },
  {
    type: '3 BHK (M2)',
    carpet: '1,424 sq.ft.',
    price: '₹4.66 Cr*',
    pricePerSqft: '₹32,700/sq.ft.*',
    wing: 'C&D Wing',
    features: ['Spacious Living', 'Utility', '3 Washrooms'],
    popular: false,
  },
  {
    type: '3 BHK (M1)',
    carpet: '1,537 sq.ft.',
    price: '₹5.02 Cr*',
    pricePerSqft: '₹32,700/sq.ft.*',
    wing: 'A&B / C&D Wing',
    features: ['Servant Room', 'Utility', 'Large Deck'],
    popular: true,
  },
  {
    type: '3 BHK (L)',
    carpet: '1,864 sq.ft.',
    price: '₹6.10 Cr*',
    pricePerSqft: '₹32,700/sq.ft.*',
    wing: 'D Wing',
    features: ['Walk-in Wardrobe', 'Servant Room', '273 sq.ft. Deck'],
    popular: false,
  },
  {
    type: '4 BHK',
    carpet: '2,487 sq.ft.',
    price: '₹8.13 Cr*',
    pricePerSqft: '₹32,700/sq.ft.*',
    wing: 'D Wing',
    features: ['4 Bedrooms', 'Servant Room', '284 sq.ft. Deck'],
    popular: false,
  },
];

// Legacy floorPlanTabs format (updated with correct areas)
export const floorPlanTabs = [
  {
    id: '2bhk',
    type: '2 BHK (886 sq.ft.)',
    carpet: '886 sq.ft.',
    wing: 'A&B Wing',
    bedrooms: 2,
    bathrooms: 2,
    features: ['Living Room', 'Dining Area', 'Kitchen', 'Deck'],
    highlights: 'Compact luxury with efficient layout. RERA Carpet: 823.55 + Deck: 62.32 sq.ft.',
  },
  {
    id: '3bhk-s',
    type: '3 BHK S (1,068 sq.ft.)',
    carpet: '1,068 sq.ft.',
    wing: 'C&D Wing',
    bedrooms: 3,
    bathrooms: 3,
    features: ['Living Room', 'Dining Area', 'Kitchen', 'Deck'],
    highlights: 'Entry-level 3BHK. RERA Carpet: 1,006.11 + Deck: 62.32 sq.ft.',
  },
  {
    id: '3bhk-m2',
    type: '3 BHK M2 (1,424 sq.ft.)',
    carpet: '1,424 sq.ft.',
    wing: 'D Wing',
    bedrooms: 3,
    bathrooms: 3,
    features: ['Living Room', 'Dining Area', 'Kitchen', 'Utility', 'Deck'],
    highlights: 'Efficient layout with utility. RERA Carpet: 1,257.77 + Deck: 141.44 + Utility: 24.65 sq.ft.',
  },
  {
    id: '3bhk-m1',
    type: '3 BHK M1 (1,537 sq.ft.)',
    carpet: '1,537 sq.ft.',
    wing: 'A&B / C&D Wing',
    bedrooms: 3,
    bathrooms: 3,
    features: ['Living Room', 'Dining Area', 'Kitchen', 'Servant Room', 'Utility', 'Large Deck'],
    highlights: 'Spacious with servant room. RERA Carpet: 1,319.67 + Deck: 183.31 + Utility: 33.69 sq.ft.',
  },
  {
    id: '3bhk-l',
    type: '3 BHK L (1,864 sq.ft.)',
    carpet: '1,864 sq.ft.',
    wing: 'D Wing',
    bedrooms: 3,
    bathrooms: 3,
    features: ['Living Room', 'Dining Area', 'Kitchen', 'Walk-in Wardrobe', 'Servant Room', 'Extra Large Deck'],
    highlights: 'Premium with 273 sq.ft. deck. RERA Carpet: 1,564.33 + Deck: 273.08 + Utility: 26.69 sq.ft.',
  },
  {
    id: '4bhk',
    type: '4 BHK (2,487 sq.ft.)',
    carpet: '2,487 sq.ft.',
    wing: 'D Wing',
    bedrooms: 4,
    bathrooms: 4,
    features: ['Living Room', 'Dining Area', 'Kitchen', 'Walk-in Wardrobe', 'Servant Room', 'Premium Deck'],
    highlights: 'Ultra-luxury with 284 sq.ft. deck. RERA Carpet: 2,177.56 + Deck: 284.38 + Utility: 24.65 sq.ft.',
  },
];

// Amenities
export const amenities = {
  featured: [
    { name: 'Swimming Pool', icon: 'Waves', description: 'Temperature-controlled pool with lounging deck' },
    { name: 'Fitness Center', icon: 'Dumbbell', description: 'State-of-the-art gym with modern equipment' },
    { name: 'Landscaped Gardens', icon: 'TreePine', description: 'Curated green spaces for relaxation' },
  ],
  other: [
    { name: 'Jogging Track', icon: 'Footprints' },
    { name: 'Kids Play Area', icon: 'Baby' },
    { name: 'Indoor Games', icon: 'Gamepad2' },
    { name: 'Podium Lounge', icon: 'Building' },
    { name: 'Multi-purpose Hall', icon: 'Users' },
    { name: 'Senior Citizen Area', icon: 'Heart' },
    { name: 'Yoga Deck', icon: 'Flower2' },
    { name: '24/7 Security', icon: 'Shield' },
  ],
};

// Connectivity
export const connectivity = [
  { label: 'Sakinaka Metro Station', distance: '~5 mins drive', icon: 'Train' },
  { label: 'Powai Business Hub', distance: '~10 mins drive', icon: 'Building' },
  { label: 'JVLR Connectivity', distance: '~3 mins drive', icon: 'Car' },
  { label: 'Premium Schools', distance: '~5 mins drive', icon: 'GraduationCap' },
  { label: 'Hospitals', distance: '~10 mins drive', icon: 'Heart' },
  { label: 'Shopping Malls', distance: '~8 mins drive', icon: 'ShoppingBag' },
  { label: 'Mumbai Airport', distance: '~25 mins drive', icon: 'Plane' },
  { label: 'IIT Bombay', distance: '~12 mins drive', icon: 'BookOpen' },
];

// FAQs
export const faqs = [
  {
    question: 'What are the configurations available at Nahar Chandi Valley?',
    answer: 'Nahar Chandi Valley offers uber-luxury 3 BHK and 4 BHK residences with carpet areas starting from 1,069+ sq.ft. Each unit features thoughtfully designed layouts with modern amenities.',
  },
  {
    question: 'What is the starting price for apartments at Nahar Chandi Valley?',
    answer: 'Apartments at Nahar Chandi Valley start from ₹3.50 Crore onwards (indicative). Prices vary based on configuration, floor, and view. Contact us for the latest pricing and exclusive offers.',
  },
  {
    question: 'When is the expected possession for Nahar Chandi Valley?',
    answer: 'Possession is expected to start from December 2030, subject to necessary approvals and construction progress. We recommend contacting our sales team for the most current timeline.',
  },
  {
    question: 'What is the RERA registration number for Nahar Chandi Valley?',
    answer: 'Nahar Chandi Valley is registered under MahaRERA with registration number P51800002500059. You can verify this on the official MahaRERA website.',
  },
  {
    question: 'What amenities are available at Nahar Chandi Valley?',
    answer: 'The project offers world-class amenities including a swimming pool, fully-equipped fitness center, landscaped gardens, jogging track, kids play area, indoor games, podium lounge, multi-purpose hall, and 24/7 security. (Indicative; subject to change)',
  },
  {
    question: 'What is the location advantage of Nahar Chandi Valley?',
    answer: 'Located in Chandivali near Powai, Mumbai, the project enjoys excellent connectivity to JVLR, Sakinaka Metro, premium schools, hospitals, and major business hubs while being nestled in a serene residential enclave.',
  },
  {
    question: 'Who is the developer of Nahar Chandi Valley?',
    answer: 'Nahar Chandi Valley is developed by Nahar Group, a legacy developer known for quality construction and timely delivery in Mumbai\'s real estate market.',
  },
  {
    question: 'Are there any payment plans available?',
    answer: 'Yes, flexible payment plans are available. Contact our sales team for details on construction-linked plans, subvention schemes, and bank loan assistance.',
  },
  {
    question: 'Is the project Vastu compliant?',
    answer: 'Yes, all units at Nahar Chandi Valley are designed following Vastu principles to ensure positive energy flow and optimal space utilization.',
  },
  {
    question: 'How can I schedule a site visit?',
    answer: 'You can schedule a site visit by calling our sales team, sending a WhatsApp message, or filling out the enquiry form on our website. Site visits are available 7 days a week from 10 AM to 7 PM.',
  },
];

// Gallery Images (placeholder paths - replace with actual images)
export const galleryImages = [
  { src: '/gallery/exterior-1.jpg', alt: 'Nahar Chandi Valley Building Exterior', category: 'Exterior' },
  { src: '/gallery/interior-living.jpg', alt: 'Luxury Living Room', category: 'Interior' },
  { src: '/gallery/amenity-pool.jpg', alt: 'Swimming Pool', category: 'Amenities' },
  { src: '/gallery/amenity-gym.jpg', alt: 'Fitness Center', category: 'Amenities' },
  { src: '/gallery/amenity-garden.jpg', alt: 'Landscaped Gardens', category: 'Amenities' },
  { src: '/gallery/exterior-2.jpg', alt: 'Building Evening View', category: 'Exterior' },
];

// Why This Project - Trust Layer
export const whyThisProject = [
  {
    title: 'Prime Chandivali–Powai Location',
    description: 'Nestled in one of Mumbai\'s most sought-after residential corridors with excellent connectivity.',
    icon: 'MapPin',
  },
  {
    title: 'Township Living',
    description: 'Part of an integrated development offering a self-sustained lifestyle with all essentials nearby.',
    icon: 'Building',
  },
  {
    title: 'Premium Layouts',
    description: 'Thoughtfully designed residences with large decks, cross-ventilation, and abundant natural light.',
    icon: 'Layout',
  },
  {
    title: 'Legacy Developer',
    description: 'Developed by Nahar Group with a proven track record of quality and timely delivery.',
    icon: 'Award',
  },
];

// Legal Content - India/MahaRERA Compliant
export const legalContent = {
  disclaimer: `GENERAL INFORMATION ONLY

This website is published for general informational purposes only. The content displayed herein is not intended to constitute and shall not be construed as an offer, invitation, advertisement, or solicitation for sale of any property under the Real Estate (Regulation and Development) Act, 2016 or any other applicable law.

ARTISTIC IMPRESSIONS AND REPRESENTATIONS

All images, renders, floor plans, specifications, layouts, amenities, and other visual representations displayed on this website are artistic impressions and indicative in nature. They are intended to provide a general idea of the proposed development and do not represent the actual final product. The actual built environment may differ materially from what is depicted.

NO WARRANTIES OR GUARANTEES

The developer, website operator, and their respective affiliates, agents, and representatives make no warranties, express or implied, regarding the accuracy, completeness, reliability, or suitability of any information contained on this website. All information is provided "as is" without warranty of any kind.

CHANGES AND MODIFICATIONS

The developer reserves the right to make additions, deletions, modifications, or alterations to the plans, specifications, designs, amenities, facilities, and other aspects of the project without prior notice. Pricing, availability, configurations, and possession timelines are subject to change without notice.

INDEPENDENT VERIFICATION

Prospective buyers, investors, and other interested parties are strongly advised to independently verify all details, specifications, approvals, and RERA information directly with the developer and on the official MahaRERA portal before making any purchase or investment decision. No reliance should be placed solely on the content of this website.

RERA DISCLOSURES PREVAIL

In the event of any discrepancy between the information on this website and the official disclosures made under RERA, the RERA disclosures and official documents shall prevail.

NO LIABILITY

Under no circumstances shall the developer, website operator, or their respective affiliates be liable for any loss, damage, expense, or claim arising out of or in connection with the use of this website or reliance on any information contained herein.

GOVERNING LAW

This disclaimer shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with this website shall be subject to the exclusive jurisdiction of the courts at Mumbai, Maharashtra.`,

  privacyPolicy: `1. INTRODUCTION

This Privacy Policy explains how we collect, use, disclose, and safeguard your personal information when you visit our website or submit enquiries related to Nahar's Chandi Valley ("Project"). This website is operated for informational and lead generation purposes only.

By using this website, you consent to the practices described in this Privacy Policy. If you do not agree with this policy, please do not use this website.

2. INFORMATION WE COLLECT

We may collect the following categories of information:

Personal Information Provided by You:
• Name
• Email address
• Phone number
• Any other information you voluntarily provide through enquiry forms or communications

Automatically Collected Information:
• IP address
• Browser type and version
• Device type and operating system
• Pages visited and time spent
• Referral source and navigation patterns
• Cookies and similar tracking technologies

3. PURPOSE OF DATA COLLECTION AND USE

We use your personal information for the following purposes:
• Responding to your enquiries about the Project
• Providing project information, updates, and promotional communications (with your consent)
• Internal analysis and improvement of our services and website
• Compliance with legal, regulatory, and contractual obligations
• Fraud prevention and security purposes

4. DATA SHARING AND DISCLOSURE

We may share your personal information with:
• The developer and authorized sales teams
• Customer relationship management (CRM) service providers
• IT and technology service providers
• Marketing and communication service providers
• Legal, regulatory, or governmental authorities when required by law or legal process
• Professional advisors including lawyers, auditors, and consultants

We do not sell your personal information to third parties.

5. COOKIES AND TRACKING TECHNOLOGIES

This website uses cookies and similar tracking technologies to enhance user experience and collect analytical data. These may include:
• Essential cookies for website functionality
• Analytics cookies (e.g., Google Analytics) to understand user behavior
• Marketing cookies for targeted communications

You may disable cookies through your browser settings, though this may affect website functionality.

6. DATA SECURITY

We implement reasonable security practices and procedures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.

7. YOUR RIGHTS

Subject to applicable law, you have the following rights regarding your personal information:
• Right to access your personal data
• Right to request correction of inaccurate data
• Right to request deletion of your data
• Right to withdraw consent at any time
• Right to opt-out of marketing communications

To exercise these rights, please contact us at ${projectData.contact.email}.

8. DATA RETENTION

We retain your personal information only for as long as necessary to fulfill the purposes for which it was collected, comply with legal obligations, resolve disputes, and enforce our agreements.

9. CHANGES TO THIS POLICY

We reserve the right to modify this Privacy Policy at any time without prior notice. Changes will be effective immediately upon posting on this website. Your continued use of the website after any changes constitutes acceptance of the updated policy.

10. GOVERNING LAW AND JURISDICTION

This Privacy Policy shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with this policy shall be subject to the exclusive jurisdiction of the courts at Mumbai, Maharashtra.

11. CONTACT US

For any questions or concerns regarding this Privacy Policy or your personal information, please contact us at:
Email: ${projectData.contact.email}
Phone: ${projectData.contact.phoneDisplay}`,

  termsOfService: `1. ACCEPTANCE OF TERMS

By accessing and using this website, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you must not use this website.

2. INFORMATIONAL PURPOSE ONLY

This website is published solely for informational purposes. It provides general information about Nahar's Chandi Valley ("Project"). The content on this website does not create any contractual obligation, right, or entitlement.

3. NO OFFER OR INVITATION

Nothing on this website shall constitute or be construed as:
• An offer to sell or solicitation to purchase any property
• A prospectus, advertisement, or invitation under any law
• A binding agreement or commitment of any kind
• Legal, financial, investment, or tax advice

This website is not an offer document under the Real Estate (Regulation and Development) Act, 2016 or any other applicable legislation.

4. ACCURACY OF INFORMATION

While we endeavor to provide accurate and up-to-date information, we do not warrant or guarantee the accuracy, completeness, reliability, or currency of any information on this website. All information is subject to change without prior notice, including but not limited to:
• Pricing and payment terms
• Availability of units
• Specifications and layouts
• Amenities and facilities
• Possession timelines
• Approvals and registrations

All images, renders, and visual representations are artistic impressions and indicative only.

5. INTELLECTUAL PROPERTY

All content on this website, including but not limited to text, graphics, logos, images, designs, layouts, and software, is the property of the developer or its licensors and is protected by intellectual property laws. You may not:
• Reproduce, copy, or duplicate any content without prior written consent
• Modify, adapt, or create derivative works
• Distribute, transmit, or publicly display any content
• Use any content for commercial purposes

6. USER OBLIGATIONS

By using this website, you agree to:
• Use the website only for lawful purposes
• Provide accurate and truthful information when submitting enquiries
• Not engage in any activity that may interfere with or disrupt the website
• Not attempt to gain unauthorized access to any part of the website
• Not use automated systems, bots, or scrapers to access the website

7. THIRD-PARTY LINKS

This website may contain links to third-party websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party websites. Access to such websites is at your own risk.

8. LIMITATION OF LIABILITY

To the maximum extent permitted by law:
• The developer, website operator, and their respective affiliates shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising out of or in connection with the use of this website
• We shall not be liable for any loss, damage, expense, or claim resulting from reliance on any information on this website
• We shall not be liable for any decisions made based on the content of this website

9. INDEMNIFICATION

You agree to indemnify, defend, and hold harmless the developer, website operator, and their respective affiliates, officers, directors, employees, and agents from and against any and all claims, liabilities, damages, losses, costs, and expenses (including legal fees) arising out of or in connection with your use of this website or violation of these terms.

10. MODIFICATION OF TERMS

We reserve the right to modify, update, or change these Terms and Conditions at any time without prior notice. Changes will be effective immediately upon posting. Your continued use of the website after any modifications constitutes acceptance of the updated terms.

11. SEVERABILITY

If any provision of these Terms and Conditions is found to be invalid, illegal, or unenforceable, the remaining provisions shall continue in full force and effect.

12. GOVERNING LAW AND JURISDICTION

These Terms and Conditions shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these terms or the use of this website shall be subject to the exclusive jurisdiction of the courts at Mumbai, Maharashtra.

13. CONTACT INFORMATION

For any questions regarding these Terms and Conditions, please contact us at:
Email: ${projectData.contact.email}
Phone: ${projectData.contact.phoneDisplay}`,

  reraInformation: `REAL ESTATE (REGULATION AND DEVELOPMENT) ACT, 2016

Nahar's Chandi Valley is a real estate project located in Chandivali–Powai, Mumbai, Maharashtra, India. This page provides important information regarding the project's registration under the Real Estate (Regulation and Development) Act, 2016 ("RERA").

RERA REGISTRATION STATUS

This project is registered with the Maharashtra Real Estate Regulatory Authority (MahaRERA). The registration details are as follows:

MahaRERA Registration Number: ${projectData.rera.number}
Regulatory Authority: Maharashtra Real Estate Regulatory Authority (MahaRERA)
Jurisdiction: State of Maharashtra

VERIFICATION ON OFFICIAL PORTAL

Prospective buyers and interested parties are strongly encouraged to verify the project registration and access official disclosures on the MahaRERA portal:

Official Website: https://maharera.maharashtra.gov.in

To verify:
1. Visit the official MahaRERA website
2. Navigate to "Registered Projects" or use the search function
3. Enter the registration number: ${projectData.rera.number}
4. Review the complete project details, approved plans, financial disclosures, and timeline

RERA DISCLOSURES PREVAIL

In the event of any discrepancy between the information presented on this website and the official disclosures made under RERA on the MahaRERA portal, the RERA disclosures and official registered documents shall prevail and be considered authoritative.

ABOUT RERA

The Real Estate (Regulation and Development) Act, 2016 is an Act of the Parliament of India that aims to:
• Protect the interests of homebuyers
• Ensure transparency in real estate transactions
• Establish regulatory authorities in each state
• Mandate registration of real estate projects and agents
• Provide a grievance redressal mechanism for buyers

KEY BUYER PROTECTIONS UNDER RERA

• Transparency: Developers must disclose all project details, plans, layouts, and approvals
• Accountability: Builders are accountable for timely delivery and adherence to approved plans
• Fund Security: Developers must deposit a specified percentage of project funds in a designated account
• Standardization: Carpet area calculation is standardized across the industry
• Grievance Redressal: Fast-track dispute resolution mechanism through RERA tribunals

IMPORTANT NOTICE

The information provided on this page is for general awareness purposes only. Prospective buyers are advised to:
• Independently verify all project details on the official MahaRERA portal
• Review all official documents and disclosures before making any purchase decision
• Seek independent legal and financial advice as appropriate
• Not rely solely on the information provided on this website

CONTACT FOR RERA QUERIES

For any queries regarding RERA registration or compliance, please contact:
Email: ${projectData.contact.email}
Phone: ${projectData.contact.phoneDisplay}

For official RERA complaints or grievances, please visit the MahaRERA portal directly.`,
};
